module.exports = __webpack_public_path__ + "img/PR11.653aed7e.png";